import _slicedToArray from "/codebuild/output/src2840245709/src/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2840245709/src/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/codebuild/output/src2840245709/src/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/codebuild/output/src2840245709/src/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["name", "value", "onChange", "disabled", "__demoMode", "nullable", "multiple"],
  _excluded2 = ["value", "onChange", "displayValue", "type"],
  _excluded3 = ["hold"],
  _excluded4 = ["disabled", "value"];
var _De;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import H, { Fragment as pe, createContext as J, createRef as ue, useCallback as Q, useContext as Y, useMemo as E, useReducer as se, useRef as A } from "react";
import { useComputed as W } from "../../hooks/use-computed.js";
import { useDisposables as Z } from "../../hooks/use-disposables.js";
import { useEvent as O } from "../../hooks/use-event.js";
import { useId as B } from "../../hooks/use-id.js";
import { useIsoMorphicEffect as I } from "../../hooks/use-iso-morphic-effect.js";
import { useLatestValue as be } from "../../hooks/use-latest-value.js";
import { useOutsideClick as de } from "../../hooks/use-outside-click.js";
import { useResolveButtonType as ce } from "../../hooks/use-resolve-button-type.js";
import { useSyncRefs as V } from "../../hooks/use-sync-refs.js";
import { useTreeWalker as fe } from "../../hooks/use-tree-walker.js";
import { calculateActiveIndex as me, Focus as y } from "../../utils/calculate-active-index.js";
import { disposables as ee } from "../../utils/disposables.js";
import { forwardRefWithAs as _, render as F, compact as xe, Features as te } from "../../utils/render.js";
import { isDisabledReactIssue7711 as Te } from "../../utils/bugs.js";
import { match as w } from "../../utils/match.js";
import { objectToFormEntries as Oe } from "../../utils/form.js";
import { sortByDomNode as Re } from "../../utils/focus-management.js";
import { Hidden as Ce, Features as ge } from "../../internal/hidden.js";
import { useOpenClosed as ve, State as $, OpenClosedProvider as ye } from "../../internal/open-closed.js";
import { Keys as S } from "../keyboard.js";
var Se = function (o) {
    return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
  }(Se || {}),
  Pe = function (o) {
    return o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o;
  }(Pe || {}),
  Ae = function (o) {
    return o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o;
  }(Ae || {}),
  Ie = function (t) {
    return t[t.OpenCombobox = 0] = "OpenCombobox", t[t.CloseCombobox = 1] = "CloseCombobox", t[t.GoToOption = 2] = "GoToOption", t[t.RegisterOption = 3] = "RegisterOption", t[t.UnregisterOption = 4] = "UnregisterOption", t;
  }(Ie || {});
function q(n) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (o) {
    return o;
  };
  var o = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex] : null,
    e = Re(a(n.options.slice()), function (t) {
      return t.dataRef.current.domRef.current;
    }),
    i = o ? e.indexOf(o) : null;
  return i === -1 && (i = null), {
    options: e,
    activeOptionIndex: i
  };
}
var De = (_De = {}, _defineProperty(_De, 1, function _(n) {
    return n.dataRef.current.disabled || n.comboboxState === 1 ? n : _objectSpread(_objectSpread({}, n), {}, {
      activeOptionIndex: null,
      comboboxState: 1
    });
  }), _defineProperty(_De, 0, function _(n) {
    if (n.dataRef.current.disabled || n.comboboxState === 0) return n;
    var a = n.activeOptionIndex,
      o = n.dataRef.current.isSelected,
      e = n.options.findIndex(function (i) {
        return o(i.dataRef.current.value);
      });
    return e !== -1 && (a = e), _objectSpread(_objectSpread({}, n), {}, {
      comboboxState: 0,
      activeOptionIndex: a
    });
  }), _defineProperty(_De, 2, function _(n, a) {
    var i;
    if (n.dataRef.current.disabled || n.dataRef.current.optionsRef.current && !n.dataRef.current.optionsPropsRef.current.static && n.comboboxState === 1) return n;
    var o = q(n);
    if (o.activeOptionIndex === null) {
      var t = o.options.findIndex(function (p) {
        return !p.dataRef.current.disabled;
      });
      t !== -1 && (o.activeOptionIndex = t);
    }
    var e = me(a, {
      resolveItems: function resolveItems() {
        return o.options;
      },
      resolveActiveIndex: function resolveActiveIndex() {
        return o.activeOptionIndex;
      },
      resolveId: function resolveId(t) {
        return t.id;
      },
      resolveDisabled: function resolveDisabled(t) {
        return t.dataRef.current.disabled;
      }
    });
    return _objectSpread(_objectSpread(_objectSpread({}, n), o), {}, {
      activeOptionIndex: e,
      activationTrigger: (i = a.trigger) != null ? i : 1
    });
  }), _defineProperty(_De, 3, function _(n, a) {
    var o = {
        id: a.id,
        dataRef: a.dataRef
      },
      e = q(n, function (t) {
        return [].concat(_toConsumableArray(t), [o]);
      });
    n.activeOptionIndex === null && n.dataRef.current.isSelected(a.dataRef.current.value) && (e.activeOptionIndex = e.options.indexOf(o));
    var i = _objectSpread(_objectSpread(_objectSpread({}, n), e), {}, {
      activationTrigger: 1
    });
    return n.dataRef.current.__demoMode && n.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
  }), _defineProperty(_De, 4, function _(n, a) {
    var o = q(n, function (e) {
      var i = e.findIndex(function (t) {
        return t.id === a.id;
      });
      return i !== -1 && e.splice(i, 1), e;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, n), o), {}, {
      activationTrigger: 1
    });
  }), _De),
  X = J(null);
X.displayName = "ComboboxActionsContext";
function N(n) {
  var a = Y(X);
  if (a === null) {
    var o = new Error("<".concat(n, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, N), o;
  }
  return a;
}
var z = J(null);
z.displayName = "ComboboxDataContext";
function k(n) {
  var a = Y(z);
  if (a === null) {
    var o = new Error("<".concat(n, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, k), o;
  }
  return a;
}
function Ee(n, a) {
  return w(a.type, De, n, a);
}
var he = pe,
  Le = _(function (a, o) {
    var _w3;
    var e = a.name,
      i = a.value,
      t = a.onChange,
      _a$disabled = a.disabled,
      p = _a$disabled === void 0 ? !1 : _a$disabled,
      _a$__demoMode = a.__demoMode,
      d = _a$__demoMode === void 0 ? !1 : _a$__demoMode,
      _a$nullable = a.nullable,
      r = _a$nullable === void 0 ? !1 : _a$nullable,
      _a$multiple = a.multiple,
      u = _a$multiple === void 0 ? !1 : _a$multiple,
      C = _objectWithoutProperties(a, _excluded),
      _se = se(Ee, {
        dataRef: ue(),
        comboboxState: d ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1
      }),
      _se2 = _slicedToArray(_se, 2),
      f = _se2[0],
      R = _se2[1],
      g = A(!1),
      x = A({
        static: !1,
        hold: !1
      }),
      c = A({
        displayValue: void 0
      }),
      m = A(null),
      U = A(null),
      M = A(null),
      h = A(null),
      D = O(function (s, b) {
        return s === b;
      }),
      T = Q(function (s) {
        var _w;
        return w(l.mode, (_w = {}, _defineProperty(_w, 1, function _() {
          return i.some(function (b) {
            return D(b, s);
          });
        }), _defineProperty(_w, 0, function _() {
          return D(i, s);
        }), _w));
      }, [i]),
      l = E(function () {
        return _objectSpread(_objectSpread({}, f), {}, {
          optionsPropsRef: x,
          inputPropsRef: c,
          labelRef: m,
          inputRef: U,
          buttonRef: M,
          optionsRef: h,
          value: i,
          disabled: p,
          mode: u ? 1 : 0,
          get activeOptionIndex() {
            if (g.current && f.activeOptionIndex === null && f.options.length > 0) {
              var s = f.options.findIndex(function (b) {
                return !b.dataRef.current.disabled;
              });
              if (s !== -1) return s;
            }
            return f.activeOptionIndex;
          },
          compare: D,
          isSelected: T,
          nullable: r,
          __demoMode: d
        });
      }, [i, p, u, r, d, f]);
    I(function () {
      f.dataRef.current = l;
    }, [l]), de([l.buttonRef, l.inputRef, l.optionsRef], function () {
      return R({
        type: 1
      });
    }, l.comboboxState === 0);
    var j = E(function () {
        return {
          open: l.comboboxState === 0,
          disabled: p,
          activeIndex: l.activeOptionIndex,
          activeOption: l.activeOptionIndex === null ? null : l.options[l.activeOptionIndex].dataRef.current.value
        };
      }, [l, p]),
      v = Q(function () {
        var b;
        if (!l.inputRef.current) return;
        var s = c.current.displayValue;
        typeof s == "function" ? l.inputRef.current.value = (b = s(i)) != null ? b : "" : typeof i == "string" ? l.inputRef.current.value = i : l.inputRef.current.value = "";
      }, [i, l.inputRef, c]),
      P = O(function (s) {
        var b = l.options.find(function (L) {
          return L.id === s;
        });
        !b || (K(b.dataRef.current.value), v());
      }),
      G = O(function () {
        if (l.activeOptionIndex !== null) {
          var _l$options$l$activeOp = l.options[l.activeOptionIndex],
            s = _l$options$l$activeOp.dataRef,
            b = _l$options$l$activeOp.id;
          K(s.current.value), v(), R({
            type: 2,
            focus: y.Specific,
            id: b
          });
        }
      }),
      oe = O(function () {
        R({
          type: 0
        }), g.current = !0;
      }),
      ne = O(function () {
        R({
          type: 1
        }), g.current = !1;
      }),
      re = O(function (s, b, L) {
        return g.current = !1, s === y.Specific ? R({
          type: 2,
          focus: y.Specific,
          id: b,
          trigger: L
        }) : R({
          type: 2,
          focus: s,
          trigger: L
        });
      }),
      ie = O(function (s, b) {
        return R({
          type: 3,
          id: s,
          dataRef: b
        }), function () {
          return R({
            type: 4,
            id: s
          });
        };
      }),
      K = O(function (s) {
        var _w2;
        return w(l.mode, (_w2 = {}, _defineProperty(_w2, 0, function _() {
          return t(s);
        }), _defineProperty(_w2, 1, function _() {
          var b = l.value.slice(),
            L = b.indexOf(s);
          return L === -1 ? b.push(s) : b.splice(L, 1), t(b);
        }), _w2));
      }),
      ae = E(function () {
        return {
          onChange: K,
          registerOption: ie,
          goToOption: re,
          closeCombobox: ne,
          openCombobox: oe,
          selectActiveOption: G,
          selectOption: P
        };
      }, []);
    I(function () {
      l.comboboxState === 1 && v();
    }, [v, l.comboboxState]), I(v, [v]);
    var le = o === null ? {} : {
      ref: o
    };
    return H.createElement(X.Provider, {
      value: ae
    }, H.createElement(z.Provider, {
      value: l
    }, H.createElement(ye, {
      value: w(l.comboboxState, (_w3 = {}, _defineProperty(_w3, 0, $.Open), _defineProperty(_w3, 1, $.Closed), _w3))
    }, e != null && i != null && Oe(_defineProperty({}, e, i)).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        s = _ref2[0],
        b = _ref2[1];
      return H.createElement(Ce, _objectSpread({
        features: ge.Hidden
      }, xe({
        key: s,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        name: s,
        value: b
      })));
    }), F({
      ourProps: le,
      theirProps: C,
      slot: j,
      defaultTag: he,
      name: "Combobox"
    }))));
  }),
  Me = "input",
  _e = _(function (a, o) {
    var h, D;
    var e = a.value,
      i = a.onChange,
      t = a.displayValue,
      _a$type = a.type,
      p = _a$type === void 0 ? "text" : _a$type,
      d = _objectWithoutProperties(a, _excluded2),
      r = k("Combobox.Input"),
      u = N("Combobox.Input"),
      C = V(r.inputRef, o),
      f = r.inputPropsRef,
      R = "headlessui-combobox-input-".concat(B()),
      g = Z();
    I(function () {
      f.current.displayValue = t;
    }, [t, f]);
    var x = O(function (T) {
        var _w4, _w5;
        switch (T.key) {
          case S.Backspace:
          case S.Delete:
            if (r.comboboxState !== 0 || r.mode !== 0 || !r.nullable) return;
            var l = T.currentTarget;
            g.requestAnimationFrame(function () {
              l.value === "" && (u.onChange(null), r.optionsRef.current && (r.optionsRef.current.scrollTop = 0), u.goToOption(y.Nothing));
            });
            break;
          case S.Enter:
            if (r.comboboxState !== 0) return;
            if (T.preventDefault(), T.stopPropagation(), r.activeOptionIndex === null) {
              u.closeCombobox();
              return;
            }
            u.selectActiveOption(), r.mode === 0 && u.closeCombobox();
            break;
          case S.ArrowDown:
            return T.preventDefault(), T.stopPropagation(), w(r.comboboxState, (_w4 = {}, _defineProperty(_w4, 0, function _() {
              u.goToOption(y.Next);
            }), _defineProperty(_w4, 1, function _() {
              u.openCombobox();
            }), _w4));
          case S.ArrowUp:
            return T.preventDefault(), T.stopPropagation(), w(r.comboboxState, (_w5 = {}, _defineProperty(_w5, 0, function _() {
              u.goToOption(y.Previous);
            }), _defineProperty(_w5, 1, function _() {
              u.openCombobox(), g.nextFrame(function () {
                r.value || u.goToOption(y.Last);
              });
            }), _w5));
          case S.Home:
          case S.PageUp:
            return T.preventDefault(), T.stopPropagation(), u.goToOption(y.First);
          case S.End:
          case S.PageDown:
            return T.preventDefault(), T.stopPropagation(), u.goToOption(y.Last);
          case S.Escape:
            return r.comboboxState !== 0 ? void 0 : (T.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && T.stopPropagation(), u.closeCombobox());
          case S.Tab:
            if (r.comboboxState !== 0) return;
            u.selectActiveOption(), u.closeCombobox();
            break;
        }
      }),
      c = O(function (T) {
        u.openCombobox(), i == null || i(T);
      }),
      m = W(function () {
        if (!!r.labelRef.current) return [r.labelRef.current.id].join(" ");
      }, [r.labelRef.current]),
      U = E(function () {
        return {
          open: r.comboboxState === 0,
          disabled: r.disabled
        };
      }, [r]),
      M = {
        ref: C,
        id: R,
        role: "combobox",
        type: p,
        "aria-controls": (h = r.optionsRef.current) == null ? void 0 : h.id,
        "aria-expanded": r.disabled ? void 0 : r.comboboxState === 0,
        "aria-activedescendant": r.activeOptionIndex === null || (D = r.options[r.activeOptionIndex]) == null ? void 0 : D.id,
        "aria-multiselectable": r.mode === 1 ? !0 : void 0,
        "aria-labelledby": m,
        disabled: r.disabled,
        onKeyDown: x,
        onChange: c
      };
    return F({
      ourProps: M,
      theirProps: d,
      slot: U,
      defaultTag: Me,
      name: "Combobox.Input"
    });
  }),
  Fe = "button",
  we = _(function (a, o) {
    var x;
    var e = k("Combobox.Button"),
      i = N("Combobox.Button"),
      t = V(e.buttonRef, o),
      p = "headlessui-combobox-button-".concat(B()),
      d = Z(),
      r = O(function (c) {
        switch (c.key) {
          case S.ArrowDown:
            return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && i.openCombobox(), d.nextFrame(function () {
              var m;
              return (m = e.inputRef.current) == null ? void 0 : m.focus({
                preventScroll: !0
              });
            });
          case S.ArrowUp:
            return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && (i.openCombobox(), d.nextFrame(function () {
              e.value || i.goToOption(y.Last);
            })), d.nextFrame(function () {
              var m;
              return (m = e.inputRef.current) == null ? void 0 : m.focus({
                preventScroll: !0
              });
            });
          case S.Escape:
            return e.comboboxState !== 0 ? void 0 : (c.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && c.stopPropagation(), i.closeCombobox(), d.nextFrame(function () {
              var m;
              return (m = e.inputRef.current) == null ? void 0 : m.focus({
                preventScroll: !0
              });
            }));
          default:
            return;
        }
      }),
      u = O(function (c) {
        if (Te(c.currentTarget)) return c.preventDefault();
        e.comboboxState === 0 ? i.closeCombobox() : (c.preventDefault(), i.openCombobox()), d.nextFrame(function () {
          var m;
          return (m = e.inputRef.current) == null ? void 0 : m.focus({
            preventScroll: !0
          });
        });
      }),
      C = W(function () {
        if (!!e.labelRef.current) return [e.labelRef.current.id, p].join(" ");
      }, [e.labelRef.current, p]),
      f = E(function () {
        return {
          open: e.comboboxState === 0,
          disabled: e.disabled
        };
      }, [e]),
      R = a,
      g = {
        ref: t,
        id: p,
        type: ce(a, e.buttonRef),
        tabIndex: -1,
        "aria-haspopup": !0,
        "aria-controls": (x = e.optionsRef.current) == null ? void 0 : x.id,
        "aria-expanded": e.disabled ? void 0 : e.comboboxState === 0,
        "aria-labelledby": C,
        disabled: e.disabled,
        onClick: u,
        onKeyDown: r
      };
    return F({
      ourProps: g,
      theirProps: R,
      slot: f,
      defaultTag: Fe,
      name: "Combobox.Button"
    });
  }),
  ke = "label",
  Ue = _(function (a, o) {
    var e = k("Combobox.Label"),
      i = "headlessui-combobox-label-".concat(B()),
      t = V(e.labelRef, o),
      p = O(function () {
        var C;
        return (C = e.inputRef.current) == null ? void 0 : C.focus({
          preventScroll: !0
        });
      }),
      d = E(function () {
        return {
          open: e.comboboxState === 0,
          disabled: e.disabled
        };
      }, [e]);
    return F({
      ourProps: {
        ref: t,
        id: i,
        onClick: p
      },
      theirProps: a,
      slot: d,
      defaultTag: ke,
      name: "Combobox.Label"
    });
  }),
  Be = "ul",
  Ve = te.RenderStrategy | te.Static,
  je = _(function (a, o) {
    var g;
    var _a$hold = a.hold,
      e = _a$hold === void 0 ? !1 : _a$hold,
      i = _objectWithoutProperties(a, _excluded3),
      t = k("Combobox.Options"),
      p = V(t.optionsRef, o),
      d = "headlessui-combobox-options-".concat(B()),
      r = ve(),
      u = function () {
        return r !== null ? r === $.Open : t.comboboxState === 0;
      }();
    I(function () {
      var x;
      t.optionsPropsRef.current.static = (x = a.static) != null ? x : !1;
    }, [t.optionsPropsRef, a.static]), I(function () {
      t.optionsPropsRef.current.hold = e;
    }, [t.optionsPropsRef, e]), fe({
      container: t.optionsRef.current,
      enabled: t.comboboxState === 0,
      accept: function accept(x) {
        return x.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : x.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      },
      walk: function walk(x) {
        x.setAttribute("role", "none");
      }
    });
    var C = W(function () {
        var x, c, m;
        return (m = (x = t.labelRef.current) == null ? void 0 : x.id) != null ? m : (c = t.buttonRef.current) == null ? void 0 : c.id;
      }, [t.labelRef.current, t.buttonRef.current]),
      f = E(function () {
        return {
          open: t.comboboxState === 0
        };
      }, [t]),
      R = {
        "aria-activedescendant": t.activeOptionIndex === null || (g = t.options[t.activeOptionIndex]) == null ? void 0 : g.id,
        "aria-labelledby": C,
        role: "listbox",
        id: d,
        ref: p
      };
    return F({
      ourProps: R,
      theirProps: i,
      slot: f,
      defaultTag: Be,
      features: Ve,
      visible: u,
      name: "Combobox.Options"
    });
  }),
  Ge = "li",
  He = _(function (a, o) {
    var l, j;
    var _a$disabled2 = a.disabled,
      e = _a$disabled2 === void 0 ? !1 : _a$disabled2,
      i = a.value,
      t = _objectWithoutProperties(a, _excluded4),
      p = k("Combobox.Option"),
      d = N("Combobox.Option"),
      r = "headlessui-combobox-option-".concat(B()),
      u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex].id === r : !1,
      C = p.isSelected(i),
      f = A(null),
      R = be({
        disabled: e,
        value: i,
        domRef: f,
        textValue: (j = (l = f.current) == null ? void 0 : l.textContent) == null ? void 0 : j.toLowerCase()
      }),
      g = V(o, f),
      x = O(function () {
        return d.selectOption(r);
      });
    I(function () {
      return d.registerOption(r, R);
    }, [R, r]);
    var c = A(!p.__demoMode);
    I(function () {
      if (!p.__demoMode) return;
      var v = ee();
      return v.requestAnimationFrame(function () {
        c.current = !0;
      }), v.dispose;
    }, []), I(function () {
      if (p.comboboxState !== 0 || !u || !c.current || p.activationTrigger === 0) return;
      var v = ee();
      return v.requestAnimationFrame(function () {
        var P, G;
        (G = (P = f.current) == null ? void 0 : P.scrollIntoView) == null || G.call(P, {
          block: "nearest"
        });
      }), v.dispose;
    }, [f, u, p.comboboxState, p.activationTrigger, p.activeOptionIndex]);
    var m = O(function (v) {
        var P;
        if (e) return v.preventDefault();
        x(), p.mode === 0 && (d.closeCombobox(), (P = p.inputRef.current) == null || P.focus({
          preventScroll: !0
        }));
      }),
      U = O(function () {
        if (e) return d.goToOption(y.Nothing);
        d.goToOption(y.Specific, r);
      }),
      M = O(function () {
        e || u || d.goToOption(y.Specific, r, 0);
      }),
      h = O(function () {
        e || !u || p.optionsPropsRef.current.hold || d.goToOption(y.Nothing);
      }),
      D = E(function () {
        return {
          active: u,
          selected: C,
          disabled: e
        };
      }, [u, C, e]);
    return F({
      ourProps: {
        id: r,
        ref: g,
        role: "option",
        tabIndex: e === !0 ? void 0 : -1,
        "aria-disabled": e === !0 ? !0 : void 0,
        "aria-selected": C === !0 ? !0 : void 0,
        disabled: void 0,
        onClick: m,
        onFocus: U,
        onPointerMove: M,
        onMouseMove: M,
        onPointerLeave: h,
        onMouseLeave: h
      },
      theirProps: t,
      slot: D,
      defaultTag: Ge,
      name: "Combobox.Option"
    });
  }),
  Ot = Object.assign(Le, {
    Input: _e,
    Button: we,
    Label: Ue,
    Options: je,
    Option: He
  });
export { Ot as Combobox };